import type { ComponentType } from 'react';
import type { CustomDrawerProps } from './TablemaintPage';
import BilltoEditDrawer from './BilltoEditDrawer';
import CustomersEditDrawer from './CustomersEditDrawer';
import BrokerForwarderEditDrawer from './BrokerForwarderEditDrawer';
import CarrierProfileEditDrawer from './CarrierProfileEditDrawer';
import KleinschmidtPartnersEditDrawer from './KleinschmidtPartnersEditDrawer';
import KleinschmidtEventsEditDrawer from './KleinschmidtEventsEditDrawer';
import MelroseTemplateMapEditDrawer from './MelroseTemplateMapEditDrawer';
import MelroseOrdersEditDrawer from './MelroseOrdersEditDrawer';
import PortsEditDrawer from './PortsEditDrawer';
import ScacProfileEditDrawer from './ScacProfileEditDrawer';
import ScacInfoEditDrawer from './ScacInfoEditDrawer';
import ScacEmptyLocationsEditDrawer from './ScacEmptyLocationsEditDrawer';
import ScacPerDiemEditDrawer from './ScacPerDiemEditDrawer';
import CustomChassisChargesEditDrawer from './CustomChassisChargesEditDrawer';
import CustomerPerdiemEditDrawer from './CustomerPerdiemEditDrawer';
import DalTileTemplateMapEditDrawer from './DalTileTemplateMapEditDrawer';
import ThdTemplateMapEditDrawer from './ThdTemplateMapEditDrawer';
import DriverPayOpenLegsDrawer from './DriverPayOpenLegsDrawer';
import Edi997DetailDrawer from './Edi997DetailDrawer';
import EdiChargeCodeMapEditDrawer from './EdiChargeCodeMapEditDrawer';
import EdiCsrsEditDrawer from './EdiCsrsEditDrawer';
import EdiDocumentSetupEditDrawer from './EdiDocumentSetupEditDrawer';
import EdiEventsEditDrawer from './EdiEventsEditDrawer';
import EdiInventoryAdjEditDrawer from './EdiInventoryAdjEditDrawer';
import EdiLocationsEditDrawer from './EdiLocationsEditDrawer';
import EdiOrdersEditDrawer from './EdiOrdersEditDrawer';
import EdiInvoiceSetupEditDrawer from './EdiInvoiceSetupEditDrawer';
import FscTariffEditDrawer from './FscTariffEditDrawer';
import AdditionalChargesEditDrawer from './AdditionalChargesEditDrawer';
import RatezoneMileageEditDrawer from './RatezoneMileageEditDrawer';
import QuoteChargeMappingEditDrawer from './QuoteChargeMappingEditDrawer';

/**
 * Per-table bespoke edit drawers, keyed by registry `key`. <TablemaintPage> uses
 * the matching component (if any) in place of the generic field-spec drawer.
 */
export const CUSTOM_DRAWERS: Record<string, ComponentType<CustomDrawerProps>> = {
  billtos: BilltoEditDrawer,
  customers: CustomersEditDrawer,
  brokerforwarder: BrokerForwarderEditDrawer,
  carrierprofile: CarrierProfileEditDrawer,
  'kleinschmidt-partners': KleinschmidtPartnersEditDrawer,
  'kleinschmidt-events': KleinschmidtEventsEditDrawer,
  'melrose-templatemap': MelroseTemplateMapEditDrawer,
  'melrose-orders': MelroseOrdersEditDrawer,
  ports: PortsEditDrawer,
  scacprofiles: ScacProfileEditDrawer,
  scacinfo: ScacInfoEditDrawer,
  scacempty: ScacEmptyLocationsEditDrawer,
  sslperdiem: ScacPerDiemEditDrawer,
  customchassischarges: CustomChassisChargesEditDrawer,
  'customer-perdiem': CustomerPerdiemEditDrawer,
  'daltile-templatemap': DalTileTemplateMapEditDrawer,
  'thd-templatemap': ThdTemplateMapEditDrawer,
  'driverpay-open-legs': DriverPayOpenLegsDrawer,
  'edi-997': Edi997DetailDrawer,
  'edi-chargecodemap': EdiChargeCodeMapEditDrawer,
  'edi-csrs': EdiCsrsEditDrawer,
  'edi-document-setup': EdiDocumentSetupEditDrawer,
  'edi-events': EdiEventsEditDrawer,
  'edi-inventory-adj': EdiInventoryAdjEditDrawer,
  'edi-locations': EdiLocationsEditDrawer,
  'edi-orders': EdiOrdersEditDrawer,
  'edi-invoice-setup': EdiInvoiceSetupEditDrawer,
  'fsc-tariff': FscTariffEditDrawer,
  additionalcharges: AdditionalChargesEditDrawer,
  ratezonemileage: RatezoneMileageEditDrawer,
  'invoice-litype-charge-map': QuoteChargeMappingEditDrawer,
};
